export default {
    title: "Import orders",
    upload_label: "Please upload a .csv file",
    help_center: "View help center",
    select_branch: "Please select the branch",
    one_row_per_product: "Does the CSV contain one row per product?",
    loading_message: "Sending data, this may take a few minutes...",
    file_size_error: "The file must be up to {0}MB",
    csv_error: "An error occurred while reading the CSV, check if the file is valid",
    order_id_required: "Select the Order Id column to continue. It is required and identifies each order.",
    include_time: "Includes time too",
    format: "Format",
    decimal_separator: "Decimal Separator",
    full_name: "Contains full name",
    default_prefix: "Default area code",
    products: "Products",
    brand: "Brand",
    category: "Category",
    price: "Price",
    cost: "Cost",
    summary: {
        new_clients: "New clients",
        new_orders: "New orders",
        updated_status: "Status updates",
        already_imported: "Orders that already existed and were not imported",
        failed_rows: "Failed rows:",
    },
    download_csv: "Download CSV",
    cancel: "Cancel",
    next: "Next",
    back: "Back",
    import: "Import",
    close: "Close",
    queued_message: "Import submitted! It will be processed in the background.",
    queued_link: "Track it in the import history",
    open_button: "Import orders",
    columns: {
        external_id: "Order Id",
        client_external_id: "Client Id",
        date: "Date",
        time: "Time",
        value: "Value",
        first_name: "First name",
        last_name: "Last name",
        whatsapp: "Phone",
        email: "Email",
        birthdate: "Birthdate",
        external_status: "Order Status",
        status: "Kevi Status",
        product_external_id: "Product Id",
        product_name: "Product Name",
        category: "Product Category",
        brand: "Product Brand",
        price: "Product Price",
        cost: "Product Cost",
        quantity: "Product Quantity",
    },
};
